module.exports = __webpack_public_path__ + "static/joymap-logo@3x-71303542abd466801334692a4cf90e55.png";